import {Button} from '../../kit-components/Button';
import {  OTP } from '../../kit-components/OTP';
import React,{ useState } from 'react';
import styles from './otp-step.module.scss';


export default function OtpStep(props) {
  const { loading, handleConfirmTransaction, handleResendOtp } = props;

  const [otp, setOtp] = useState('');
  const [errorMessage, setErrorMessage] = useState(null);
  const handleSubmit = async () => {
    const res = await handleConfirmTransaction(otp);
    if (res.status === 400){
        setErrorMessage(res.data.message);
    }
  };
  const handleResend = async () => {
    const res = await handleResendOtp();
    console.log("rsssss",res);
    if (res.status === 400){
      setErrorMessage(res.data.message);
    }
  };
  return (
    <div>
       {errorMessage && (
        <p className={styles['error-message']}>{errorMessage}</p>
      )} 

      <span className={styles['hint']}>
        Please enter the 5-digit code sent to
      </span>

      <div className={styles['otp-container']}>
        <OTP
          length={5}
          onComplete={(otp) => {
            setOtp(otp);
          }}
        />
      </div>
      <div className={styles['receive-code']}>
        Didn’t receive code?
        <a onClick={handleResend}>Resend</a>
      </div>

      <div className={styles['actions']}>
        <Button loading={loading} label="Verify OTP" onClick={handleSubmit} />
      </div>
    </div>
  );
}
